import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "fw-bold fs-6 w-100 small-text text-break",
  style: {"color":"black"}
}
const _hoisted_3 = {
  key: 0,
  class: "d-inline small-text"
}
const _hoisted_4 = {
  key: 1,
  class: "small my-auto"
}

import { CartProduct } from '@/services/flyingBlue';
import NutriscoreDisplay from '@/components/common/nutriscore/NutriscoreDisplay.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCartChange',
  props: {
    cartProduct: {}
  },
  emits: ["switchProduct", "productTap"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;

const switchProduct = (cartProduct: CartProduct) => {
  emits('switchProduct', cartProduct);
};


return (_ctx: any,_cache: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_ctx.cartProduct.product)
    ? (_openBlock(), _createBlock(_component_ion_row, {
        key: 0,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "4",
            class: "px-3 my-auto"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                alt: "",
                class: "img-fluid",
                src: _ctx.cartProduct.product?.default_image,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('productTap', _ctx.cartProduct.product.id)))
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.cartProduct.product?.name), 1),
              _createVNode(NutriscoreDisplay, {
                class: "d-inline my-2 me-2",
                rating: _ctx.cartProduct.product.nutriscore_grade ?? 'a'
              }, null, 8, ["rating"]),
              (_ctx.cartProduct.product?.weight > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(Number(_ctx.cartProduct.product?.weight)?.toFixed(2)) + "kg ", 1))
                : _createCommentVNode("", true),
              (_ctx.cartProduct.product?.weight == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.cartProduct.product?.packaging_label), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createVNode(_component_ion_button, {
                  size: "small",
                  color: "medium",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (switchProduct(_ctx.cartProduct)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" choisir ")
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.cartProduct?.price) + "€ ", 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})